import React from "react";
import { ArrowRightIcon, GiftIcon } from "lucide-react";
import { bonuses } from "../../data/content";
import { TransformCta } from "../ui/TransformCta";
export function Bonuses() {
  return <section className="bg-brand-900 py-16 sm:py-24" aria-labelledby="bonus-title" data-id="element-97" data-mp="1ckoakp7e3sey">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-98" data-mp="18jul3reau5jy">
        <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 text-sm font-black uppercase tracking-wide text-brand-900" data-id="element-99" data-mp="18lfh7lg9hwjx">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="20a8upbfa4vpt" />
          Exclusive bonuses
        </span>
        <h2 id="bonus-title" className="mt-5 font-serif text-[2rem] font-black leading-[1.12] text-white sm:text-5xl" data-id="element-101" data-mp="1w8nilsakklgo">
          And today I'm giving you <em className="italic text-brand-300" data-id="element-102" data-mp="1r9sss6e6pwn2">5 bonus resources FREE</em>
        </h2>
        <p className="mt-4 text-lg text-brand-100" data-id="element-103" data-mp="kvl4d3vy07zo">
          Reference value: <span className="font-bold text-white line-through decoration-rose-400 decoration-2" data-id="element-104" data-mp="funncumo5jzr">$147</span>{" "}
          — included free with REFLEXOLOGY 360°™
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-3xl space-y-6 sm:px-5" data-id="element-105" data-mp="1jshrp3gcqo3q">
        {bonuses.map(bonus => <article key={bonus.number} className="overflow-hidden bg-white sm:rounded-3xl" data-id="element-106" data-mp="15ti3ty0nyd8m">
            <div className="px-5 pt-7 text-center sm:px-9" data-id="element-107" data-mp="1artda7n1qlqb">
              <span className="inline-block rounded-full bg-brand-700 px-4 py-1.5 text-sm font-black uppercase tracking-widest text-white" data-id="element-108" data-mp="1aq8konkalcv3">
                Bonus #{bonus.number}
              </span>
              <h3 className="mt-4 font-serif text-[1.75rem] font-black leading-tight text-ink sm:text-4xl" data-id="element-109" data-mp="10v6vxstxict1">{bonus.title}</h3>
              <p className="mt-2 text-base font-semibold text-ink/60" data-id="element-110" data-mp="r42f0nkp0hvk">
                Reference value: <span className="line-through decoration-rose-500 decoration-2" data-id="element-111" data-mp="r1q0kke58pn9">${bonus.value}</span>{" "}
                <span className="ml-1 rounded-md bg-cta px-2 py-0.5 text-sm font-black uppercase text-white" data-id="element-112" data-mp="d6notgmm862j">Free today</span>
              </p>
            </div>

            <img src={bonus.image} alt={`${bonus.title} mockup`} className="mt-4 block w-full" loading="lazy" data-id="element-113" data-mp="2ju4r4a3yd4hb" />

            <div className="px-5 pb-8 sm:px-9" data-id="element-114" data-mp="2f0k3nbzzjswd">
              <p className="text-[17px] leading-relaxed text-ink/80" data-id="element-115" data-mp="2azqfqimjme3h">{bonus.intro}</p>

              {bonus.flow && <div className="mt-5 flex flex-wrap items-center justify-center gap-2 rounded-2xl bg-brand-50 p-4" data-id="element-116" data-mp="26281ccprb6o3">
                  {bonus.flow.map((step, i) => <React.Fragment key={step} data-id="element-117" data-mp="2yq3y1hfbsykv" data-mpi={i}>
                      <span className="text-base font-black uppercase tracking-wide text-brand-800" data-id="element-118" data-mp="2yqc8l2nz7rsw">{step}</span>
                      {i < bonus.flow!.length - 1 && <ArrowRightIcon className="h-4 w-4 text-brand-500" aria-hidden="true" data-id="element-119" data-mp="2orn020hyzjpb" />}
                    </React.Fragment>)}
                </div>}

              <p className="mt-5 text-sm font-bold uppercase tracking-wide text-ink/50" data-id="element-120" data-mp="1i9842t7r74eg">{bonus.listLabel}</p>
              <ul className="mt-3 flex flex-wrap gap-2" data-id="element-121" data-mp="138knclgqj1zk">
                {bonus.items.map(item => <li key={item} className="rounded-full bg-brand-100 px-3.5 py-1.5 text-[15px] font-semibold text-brand-800" data-id="element-122" data-mp="187e3ymrbj93y">
                    {item}
                  </li>)}
              </ul>
              <p className="mt-6 border-t border-brand-100 pt-5 font-serif text-lg font-bold italic leading-snug text-brand-800" data-id="element-123" data-mp="1hxyxvww1rpgj">
                {bonus.outro}
              </p>
            </div>
          </article>)}
      </div>

      <div className="px-5" data-id="element-124" data-mp="1qwkgtt5fl6hu">
        <TransformCta label="Yes! Give me all 5 bonuses free" dark data-id="element-125" data-mp="1qzyjz3lx5jqc" />
      </div>
    </section>;
}